import { render, staticRenderFns } from "./StSpScL_List.vue?vue&type=template&id=00d0436e"
import script from "./StSpScL_List.vue?vue&type=script&lang=js"
export * from "./StSpScL_List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports